import { FaPhone, FaFax, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebookF } from 'react-icons/fa';
import styles from './footer.module.css'

import { logFacebookClick } from "../../helpers/google-analytics/gaEvents";

const Footer = () => {    
    const isMobile = window.innerWidth <= 960;

    return (
        <footer className={styles.siteFooter}>
            <div className={`container ${styles.footerContent}`}>
                <div className={styles.footerSection}>
                    <h4>Contact</h4>
                    <p><FaPhone /> (506) 458-8801</p>
                    <p><FaFax /> (506) 459-3684</p>
                    <p><FaEnvelope /> 1stopkitchens@nb.aibn.com</p>

                    {!isMobile && <div className={styles.social}>
                        <div className={styles.socialLinks}>
                            <a
                                href="https://www.facebook.com/1stopkitchens"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                                onClick={logFacebookClick}
                            >
                                <FaFacebookF />
                            </a>
                        </div>
                    </div>}
                </div>

                <div className={styles.footerSection}>
                    <h4>Address</h4>
                    <p>
                        <a
                            href="https://www.google.com/maps/place/7+Royal+Parkway,+Fredericton,+NB"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.footerMapLink}
                        >
                            <FaMapMarkerAlt /> 7 Royal Parkway, Fredericton, NB
                        </a>
                    </p>
                    {/* <h4>Our Partners</h4> */}
                    {!isMobile && <div className={styles.partnersLogos}>
                        <a href="https://trianglekitchen.com/" target="_blank" rel="noopener noreferrer" aria-label="Triangle Kitchen">
                            <img src="https://ik.imagekit.io/1stopkitchens/images/partners/triangle_logo_dark.png" alt="Triangle Kitchen Logo" />
                        </a>
                        <a href="https://www.2020spaces.com/" target="_blank" rel="noopener noreferrer" aria-label="2020 Spaces">
                            <img src="https://ik.imagekit.io/1stopkitchens/images/partners/2020_technologies.png" alt="2020 Spaces" />
                        </a>
                    </div>}
                </div>

                <div className={styles.footerSection}>
                    <h4>Showroom Hours</h4>
                    <p><FaClock /> Mon–Fri: 8am – 5pm</p>
                    <p><FaClock /> Sat–Sun: Closed</p>
                    <i>*After hours consultations available upon request</i>
                </div>

                {isMobile && <>
                    <div className={`${styles.footerSection} ${styles.mobileSocial}`}>
                        <div className={styles.socialLinks}>
                            <a
                                href="https://touch.facebook.com/1stopkitchens?no_redirect=1"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <FaFacebookF />
                            </a>
                        </div>
                    </div>
                    <div className={styles.footerSection}>
                        <div className={styles.partnersLogos}>
                            <a href="https://trianglekitchen.com/" target="_blank" rel="noopener noreferrer" aria-label="Triangle Kitchen">
                                <img src="https://ik.imagekit.io/1stopkitchens/images/partners/triangle_logo_dark.png" alt="Triangle Kitchen Logo" />
                            </a>
                            <a href="https://www.2020spaces.com/" target="_blank" rel="noopener noreferrer" aria-label="2020 Spaces">
                                <img src="https://ik.imagekit.io/1stopkitchens/images/partners/2020_technologies.png" alt="2020 Spaces" />
                            </a>
                        </div>
                    </div>
                </>}
            </div>
            
            <div className={styles.footerBottom}>
                <p>&copy; {new Date().getFullYear()} 1 Stop Kitchens & Countertops LTD. All rights reserved.</p>
            </div>
        </footer>
    );
}


export default Footer

